export default __webpack_public_path__ + "images/models/f2f26d1ca7eb4d44e7e116e8c68b98f7.glb";